import React, { Component } from 'react';
import queryString from 'query-string';
import autobind from 'react-autobind';
import translate from 'app/translations';
import isBackOffice from 'utils/appUtils';
import { Link } from 'react-router-dom';
import {
  Row,
  Col,
  Drawer,
  Button,
  Divider,
  Breadcrumb,
} from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { PROFILE_STEP_TYPES } from 'app/constants';
import AgentProfilePropType from './AgentProfilePropType';
import {
  fetchConstantsRequest,
  saveUserProfileRequest,
  fetchCurrentUserProfileRequest,
  saveCompanyProfileRequest,
  setAgentProfileStepRequest,
  saveServiceFeeRequest,
  saveRegionCoverageRequest,
  saveProfessionalInfoRequest,
  saveEandOInfoRequest,
  setEandODocsRequest,
  setCredentialDocuments,
  deleteCredentialDocumentRequest,
  deleteEandODocumentRequest,
  updateApplicationStatusRequest,
  approveApplicationRequest,
  fetchApplicationMessageListRequest,
  addApplicationMessageRequest,
} from './agentProfileActions';

import steps, { stepRouteToConstant } from './AgentProfileSteps';
import Stepper from './components/Stepper';
import ApplicationStatus from './components/ApplicationStatus';


import './AngentProfile.scss';

export class AgentProfileEdit extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
    this.state = {
      mobileStepperVisible: false,
    };
  }

  componentDidMount() {
    this.props.fetchConstantsRequest();
    const { accessToken } = queryString.parse(this.props.location.search);
    const { applicationId } = this.props.match.params;

    this.props.fetchCurrentUserProfileRequest(accessToken, applicationId);

    if (isBackOffice) {
      this.props.fetchApplicationMessageListRequest();
    }
  }

  onCloseMobileStepper() {
    this.setState({
      mobileStepperVisible: false,
    });
  }

  showMobileStepper() {
    this.setState({
      mobileStepperVisible: true,
    });
  }

  render() {
    const { mobileStepperVisible } = this.state;
    const { agentProfile, match } = this.props;
    const { messageList } = agentProfile;

    const currentPage = (match && match.params && match.params.currentStep && PROFILE_STEP_TYPES[stepRouteToConstant(match.params.currentStep)])
      ? PROFILE_STEP_TYPES[stepRouteToConstant(match.params.currentStep)] : PROFILE_STEP_TYPES.USER_PROFILE;

    const currentStep = steps.find(s => s.type === currentPage);

    const showStepper = (currentStep.type !== PROFILE_STEP_TYPES.COMPLETION);

    return (
      <div className="agent-profile card-container box-shadow">
        {showStepper && (
          <div id="desktopSteps">
            <Stepper
              steps={steps}
              direction="horizontal"
              currentPage={currentStep.type}
              onSetAgentProfileStepRequest={this.props.setAgentProfileStepRequest}
            />
            <Divider />
          </div>
        )}
        <div id="mobileSteps">
          <Drawer
            title={this.t('AgentProfileSteps.steps')}
            placement="left"
            onClose={this.onCloseMobileStepper}
            visible={mobileStepperVisible}
          >
            <Stepper
              steps={steps}
              direction="vertical"
              currentPage={currentStep.type}
              onSetAgentProfileStepRequest={this.props.setAgentProfileStepRequest}
            />
          </Drawer>
          <Row type="flex" justify="center">
            <Col xs={24} md={20} lg={16} xl={16}>
              <div>
                {isBackOffice && (
                  <Breadcrumb>
                    <Breadcrumb.Item>
                      <Link to="/dashboard">
                        {this.t('AgentProfileEdit.appList')}
                      </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                      {this.t('AgentProfileEdit.breadCrumbTitle')}
                    </Breadcrumb.Item>
                  </Breadcrumb>
                )}
                <div>
                  {showStepper && (
                    <Button
                      className="mobile-step-btn box-shadow float-right"
                      onClick={this.showMobileStepper}
                      icon="appstore"
                      shape="circle"
                    />
                  )}

                  <h1 className="margin-zero">{this.t(`AgentProfileSteps.${currentStep.type}`)}</h1>
                </div>
                {isBackOffice && (
                  <div>
                    <ApplicationStatus
                      agentProfile={agentProfile}
                      onUpdateApplicationStatusRequest={this.props.updateApplicationStatusRequest}
                      onApproveApplicationRequest={this.props.approveApplicationRequest}
                      messageList={messageList}
                      onAddApplicationMessageRequest={this.props.addApplicationMessageRequest}
                    />
                  </div>
                )}
                {currentStep.component && (
                  <currentStep.component
                    agentProfile={agentProfile}
                    onSaveUserProfileRequest={this.props.saveUserProfileRequest}
                    onSaveCompanyProfileRequest={this.props.saveCompanyProfileRequest}
                    onSetAgentProfileStepRequest={this.props.setAgentProfileStepRequest}
                    onSaveServiceFeeRequest={this.props.saveServiceFeeRequest}
                    onSaveRegionCoverageRequest={this.props.saveRegionCoverageRequest}
                    onSaveProfessionalInfoRequest={this.props.saveProfessionalInfoRequest}
                    onSaveEandOInfoRequest={this.props.saveEandOInfoRequest}
                    onSetEandODocsRequest={this.props.setEandODocsRequest}
                    onSetCredentialDocuments={this.props.setCredentialDocuments}
                    onDeleteCredentialDocumentRequest={this.props.deleteCredentialDocumentRequest}
                    onDeleteEandODocumentRequest={this.props.deleteEandODocumentRequest}
                  />
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

AgentProfileEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      currentStep: PropTypes.string,
      applicationId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  fetchConstantsRequest: PropTypes.func.isRequired,
  saveUserProfileRequest: PropTypes.func.isRequired,
  fetchCurrentUserProfileRequest: PropTypes.func.isRequired,
  saveCompanyProfileRequest: PropTypes.func.isRequired,
  setAgentProfileStepRequest: PropTypes.func.isRequired,
  saveServiceFeeRequest: PropTypes.func.isRequired,
  saveRegionCoverageRequest: PropTypes.func.isRequired,
  saveProfessionalInfoRequest: PropTypes.func.isRequired,
  saveEandOInfoRequest: PropTypes.func.isRequired,
  setEandODocsRequest: PropTypes.func.isRequired,
  setCredentialDocuments: PropTypes.func.isRequired,
  deleteCredentialDocumentRequest: PropTypes.func.isRequired,
  deleteEandODocumentRequest: PropTypes.func.isRequired,
  updateApplicationStatusRequest: PropTypes.func.isRequired,
  approveApplicationRequest: PropTypes.func.isRequired,
  fetchApplicationMessageListRequest: PropTypes.func.isRequired,
  addApplicationMessageRequest: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  agentProfile: state.agentProfile,
});

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    fetchConstantsRequest,
    saveUserProfileRequest,
    fetchCurrentUserProfileRequest,
    saveCompanyProfileRequest,
    setAgentProfileStepRequest,
    saveServiceFeeRequest,
    saveRegionCoverageRequest,
    saveProfessionalInfoRequest,
    saveEandOInfoRequest,
    setEandODocsRequest,
    setCredentialDocuments,
    deleteCredentialDocumentRequest,
    deleteEandODocumentRequest,
    updateApplicationStatusRequest,
    approveApplicationRequest,
    fetchApplicationMessageListRequest,
    addApplicationMessageRequest,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(AgentProfileEdit);


